import { Schema as S } from "effect";

export const LedgerBalance = S.Struct({
	accountId: S.String,
	balance: S.String,
	formatted: S.String,
	scale: S.Number,
});
export type LedgerBalance = typeof LedgerBalance.Type;

export const Direction = S.Literals(["credit", "debit"]);

export const LedgerUsageEntry = S.Struct({
	id: S.String,
	amount: S.String,
	formattedAmount: S.String,
	direction: Direction,
	description: S.optionalKey(S.String),
	metadata: S.optionalKey(S.Record(S.String, S.Unknown)),
	counterpartyAccountId: S.optionalKey(S.String),
	counterpartyAccountName: S.optionalKey(S.String),
	createdAt: S.String,
	createdBy: S.optionalKey(S.String),
});
export type LedgerUsageEntry = typeof LedgerUsageEntry.Type;

export const LedgerUsage = S.Struct({ entries: S.Array(LedgerUsageEntry) });

export const LatestUsage = S.Struct({ entry: S.NullOr(LedgerUsageEntry) });

export const SpendingSummary = S.Struct({
	today: S.String,
	thisWeek: S.String,
	thisMonth: S.String,
});

export const DailyChargeComponent = S.Struct({
	label: S.String,
	quantity: S.String,
	rate: S.String,
	amount: S.String,
});

export const DailyChargeBreakdown = S.Struct({
	date: S.String,
	total: S.String,
	components: S.Array(DailyChargeComponent),
	metadata: S.Record(S.String, S.Unknown),
});

export const DailyBreakdown = S.Struct({
	breakdown: S.NullOr(DailyChargeBreakdown),
});

export const RateCardEntry = S.Struct({
	category: S.String,
	item: S.String,
	unit: S.String,
	ourCost: S.String,
	yourCost: S.String,
});

export const RateCardVersion = S.Struct({
	version: S.String,
	effectiveDate: S.String,
	notes: S.String,
	rates: S.Array(RateCardEntry),
});
export type RateCardVersion = typeof RateCardVersion.Type;

export const RateCardHistory = S.Struct({ versions: S.Array(RateCardVersion) });
export type RateCardHistory = typeof RateCardHistory.Type;

/** Stripe session for topup, setup, and portal. */
export const LedgerSession = S.Struct({
	sessionId: S.String,
	url: S.optionalKey(S.NullOr(S.String)),
});
